import {
    Box,
    Paper, Typography, useTheme,
    RadioGroup as MuiRadioGroup,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    Icon,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { IDadosJogadoresLesionados, IDadosLesionados, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";

const tiposFiltro = [
    {
        codigo: 1,
        label: "NBA"
    },
    {
        codigo: 2,
        label: "Liga"
    },
];

export const ListagemDeLesionados: React.FC = () => {
    const theme = useTheme();    
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();    
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [redirecionar, setRedirecionar] = useState("");
    const [removeLoading, setRemoveLoading] = useState(false);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [tipoFiltro, setTipoFiltro] = useState(1);
    const [dadosLesionados, setDadosLesionados] = useState<IDadosLesionados[]>([]);
    const [lesionadosRows, setLesionadosRows] = useState<IDadosJogadoresLesionados[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });


    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );

    const columnsJogadores: GridColDef[] = [
        {
            field: 'codigo_Jogador',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: 75,
            //width: 90,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: false,
            //width: 90,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }}
                />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            description: 'Nome do Jogador da Franquia escolhido',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 190,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            //valueGetter: (params: GridValueGetterParams) =>`${params.row.nome_Jogador_Escolhido || ''}`,
        },
        {
            field: 'posicao_Jogador',
            headerName: 'POSIÇÃO',
            sortable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (carregaPosicao(params.row.posicao1_Jogador, params.row.posicao2_Jogador, params.row.posicao3_Jogador))
        },
        {
            field: "data_Retorno",
            headerName: "DATA RETORNO",
            flex: 1,
            minWidth: 100,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ? new Date(params.value).toLocaleDateString("pt-Br") : ""
        },
        {
            field: "situacao",
            headerName: "SITUAÇÃO",
            flex: 1,
            minWidth: 80,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) =>
            (
                <>
                    <Icon sx={{ fontSize: "16px", display: "flex", alignSelf: "center", backgroundColor: params.value !== "Fora" ? "yellow" : "red", color: "transparent", borderRadius: "50%", marginRight: "2px" }}>radio_button_unchecked</Icon>
                    &nbsp;&nbsp;<Typography style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}> {params.value}</Typography>
                </>
            )
        },
        {
            field: 'logo_Franquia',
            headerName: 'LOGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagemescudo.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }}
                />
                : <img src={"../../../../semimagemescudo.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
    ];

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        carregarDadosJogadoresLesionados(liga.codigo, 1);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    });
            })
        }
    }, [codigoLiga]);


    const carregarDadosJogadoresLesionados = async (codigoLiga: number, tipo: number) => {
        setIsLoading(true);
        setRemoveLoading(false);
        setTipoFiltro(tipo);

        if (tipo === 1) {
            await JogadorService.getJogadoresLesionadosNBA(codigoLiga)
                .then((result) => {
                    const dados = result.dado;
                    setDadosLesionados(dados);
                    //setLesionadosRows(dados.jogadores);
                    setIsLoading(false);
                    setRemoveLoading(true);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });

                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });
        }
        else if (tipo === 2) {
            await JogadorService.getJogadoresLesionadoLiga(codigoLiga)
                .then((result) => {
                    const dados = result.dado;
                    setDadosLesionados(dados);
                    //setLesionadosRows(dados.jogadores);
                    setIsLoading(false);
                    setRemoveLoading(true);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    if (errors.response) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });

                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });
        }
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {
        let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;        
        let qtd = posicoes.split("|").length;
        let arrImagens = posicoes.split("|");

        let imgs = qtd === 1 ? <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
            : qtd === 2 ?
                <>  <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>
                : <> <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                    <img src={arrImagens[2]} alt={"img3"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>

        return imgs
    }


    const handleChangeTipo = async (e: { target: { name: string; value: any; }; }) => {
        setTipoFiltro(e.target.value);
        setLesionadosRows([]);
        carregarDadosJogadoresLesionados(Number(codigoLiga), Number(e.target.value));

    }

    return (
        <LayoutBaseDePagina
            titulo={`Lesionados - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> Lista dos Jogadores Lesionados por Franquias </Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                                <FormControl>
                                    <FormLabel>Tipo</FormLabel>
                                    <MuiRadioGroup
                                        row
                                        name="tipo"
                                        value={tipoFiltro}
                                        onChange={handleChangeTipo}
                                    >
                                        {
                                            tiposFiltro.map(item => (<FormControlLabel key={item.codigo} value={item.codigo} control={<Radio />} label={item.label} />))
                                        }
                                    </MuiRadioGroup>
                                </FormControl >
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {dadosLesionados.length > 0 && dadosLesionados.map(f => (
                                    <>
                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                            <Grid size={{ xs: 12, sm: 12 }} display={"flex"} flexDirection={"row"} alignSelf={"center"}>
                                                <img src={f.logo_Franquia === "" || f.logo_Franquia === null ? showImagemFranquia : f.logo_Franquia} width={UtilidadeService.isMobile() ? 45 : 80} height={UtilidadeService.isMobile() ? 45 : 80} alt={f.nome_Franquia} />
                                                &nbsp; &nbsp; &nbsp;
                                                <Typography alignSelf={"center"} variant={UtilidadeService.isMobile() ? "body2" : "h6"} >{f.nome_Franquia}</Typography>
                                                &nbsp; &nbsp; &nbsp;
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={UtilidadeService.isMobile() ? 0 : 2} spacing={UtilidadeService.isMobile() ? 1 : 3}>
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <Box sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        },
                                                    }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo_Jogador}
                                                            rows={f.jogadores}
                                                            columns={columnsJogadores}
                                                            columnVisibilityModel={{ codigo_Jogador: false }}

                                                            // initialState={{
                                                            //     pagination: {
                                                            //         paginationModel: {
                                                            //             pageSize: 24,
                                                            //             page: paginaJogadores - 1,
                                                            //         },
                                                            //     },
                                                            // }}
                                                            //onRowClick={handleRedirect}
                                                            pageSizeOptions={[24, 50, 100]}
                                                            autoHeight
                                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 12 : 16,
                                                            }}
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                            hideFooter
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12 }} >
                                            <hr />
                                        </Grid>
                                    </>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}

